import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClasePerdida, ClasePerdidaForm, ClasePerdidaModalData } from '../models/clase-perdida';
import { State } from 'src/app/_state/app.state';
import { Store } from '@ngrx/store';
import { ClasePerdidaApiActions, ClasePerdidaPageActions } from '../state/actions';

@Component({
    selector: 'app-clase-perdida-modal',
    standalone: false,
    templateUrl: './clase-perdida-modal.component.html',
    styleUrls: ['./clase-perdida-modal.component.scss']
})

export class ClasePerdidaModal {

    clasePerdidaForm = this.fb.group(new ClasePerdidaForm());

    constructor(
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA) public data: ClasePerdidaModalData,
        private fb: UntypedFormBuilder,
    ) { }

    create(form: UntypedFormGroup) {
        let clasePerdida = new ClasePerdida(form);
        clasePerdida.unidadID = this.data.idUnidad;
        this.store.dispatch(ClasePerdidaPageActions.createClasePerdida({clasePerdida}));
    }

}